import styled from 'styled-components'

import Placeholder from '../../atoms/Placeholder'

import Col from '../../atoms/Col'
import Row from '../../atoms/Row'

import Image from '../../molecules/Image'

export const HeroImage = styled(Image).attrs({
  sizes: '(min-width: 992px) 35vw, 100vw',
  imgixParams: { fit: 'crop', crop: 'focal', ar: '16:9' },
})`
  width: 100%;

  @media (max-width: 991.9px) {
    ${Placeholder} {
      width: 100%;
      height: 0;
      padding-top: 56.25%;
    }
  }

  @media (min-width: 992px) {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 35%;
  }
`

export const Container = styled(Row)`
  p {
    margin: 0;
  }

  p + p {
    margin-top: 1.45rem;
  }

  ${Col} {
    flex: 1 1 100%;
    padding: ${props => props.theme.gutter * 2}px;
  }

  @media (min-width: 768px) {
    padding: 0;
    width: 100%;
    margin: ${props => props.theme.gutter}px 0 ${props => props.theme.gutter * 2}px 0;
  }

  @media (min-width: 992px) {
    position: relative;
    overflow: hidden;

    ${HeroImage} + ${Col} {
      flex: 0 0 65%;
      max-width: 65%;
    }
  }
`
